import _get from "lodash/get";

import { IEvaluation } from "../EvaluationItem/types";

import { IList } from "./types";
// 将数据转化为需要的接口
export const transformData = (data: IEvaluation[]): IList[] => {
  const res: IList[] = [];

  data?.map((item) => {
    const images = _get(item, "commentInfo.images");
    if (images?.length) {
      const { avatar, nickName } = item;
      const { content, goodsGrade, commentId } = item.commentInfo;
      res.push(
        ...images.map((image: string, index: number) => ({
          avatar,
          nickName,
          content,
          goodsGrade,
          image,
          id: `${commentId}-${index}`,
        }))
      );
    }
  }) ?? [];
  return res;
};
